import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { TradesPrompt } from "./TradesPrompt";

export const LoadingState = () => (
  <SkeletonTheme
    baseColor="var(--color-background-light)"
    highlightColor="var(--color-background)"
  >
    <div>
      <TradesPrompt />
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="mobius-ai-trade-question__trade-item mobius-ai-trade-question__trade-item--is-loading"
        >
          <Skeleton
            borderRadius="var(--radius-1)"
            containerClassName="mobius-skeleton"
          />
        </div>
      ))}
    </div>
  </SkeletonTheme>
);
